import React from 'react';

import withAppState from '../mobx/withAppState'
import { Steps } from '../lib/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import chevronLeft from '../assets/img/chevronLeft.svg'

const arrowLeft = <FontAwesomeIcon icon={faChevronLeft} />;
const elementClose = <FontAwesomeIcon icon={faTimes} />;

class TopBanner extends React.Component {
  constructor() {
    super();
    this.state = {
      backDisabled: false
    };
  }

  openModal() {
    this.props.setMainModalCTA(() => {
      this.props.popStep();
    });

    const title = 'Are you sure you want to go back?';
    const mainCTAText = 'Confirm';
    const secondaryCTAText = 'Cancel';

    this.props.setupMainModal({ title, mainCTAText, secondaryCTAText });
    this.props.enableMainModal();
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.forceUpdate();
    });
  }

  render() {
    let restaurantNameTitle = [];
    let contentTableNumber = [];
    var tableSelected = false;
    this.props.activeStep > Steps.TABLE_PICKER &&
      !!this.props.tableNumber
      ? (tableSelected = true)
      : (tableSelected = false);

    if (tableSelected) {
      var isAfterSelectTable = this.props.previousSteps.includes(
        Steps.TABLE_PICKER
      );

      contentTableNumber.push(
        <div
          key="table-container"
          className={`table-number-content ${
            !isAfterSelectTable ? 'hidden' : ''
            }`}
        >
          <p className="selected-table" key="table">
            Table&nbsp;
            {this.props.bill &&
              this.props.bill.length > 0 &&
              this.props.bill[0] &&
              this.props.bill[0].providerValues['TableNumber']}
          </p>
        </div>
      );
    } else {
    }

    if (
      this.props.activeStep > Steps.RESTAURANT_SEARCH &&
      !!this.props.restaurant &&
      !!this.props.restaurant.name
    ) {
      restaurantNameTitle.push(
        <p id="restaurantTitle" className="title" key="restaurant">
          {this.props.restaurant.name}
        </p>
      );
    }

    let currentStep = '';
    switch (this.props.activeStep) {
      case Steps.RESTAURANT_SEARCH:
        currentStep = 'Restaurant';
        break;
      case Steps.TABLE_PICKER:
        currentStep = 'Table';
        break;
      case Steps.BILL:
      case Steps.SPLIT_BILL_NAME:
      case Steps.SPLIT_BILL_MENU:
        currentStep = 'Bill';
        break;
      case Steps.APPLY_GRATUITY:
        currentStep = 'Gratutity';
        break;
      case Steps.PAY:
        currentStep = 'Payment';
        break;
      case Steps.PAYMENT_CONFIRMATION:
        currentStep = 'Payment Complete';
        break;
      case Steps.REGISTER_CONFIRMATION:
        currentStep = 'Registered';
        break;
      case Steps.APPLY_VOUCHER:
        currentStep = 'Voucher';
        break;
      case Steps.REGISTER:
        currentStep = 'Register';
        break;
      default:
        currentStep = 'Pay my Bill';
    }

    var buttonDisabled =
      this.props.previousSteps.length === 0 ||
      this.props.activeStep === Steps.RESTAURANT_SEARCH ||
      this.props.activeStep === Steps.PAYMENT_CONFIRMATION ||
      this.props.activeStep === Steps.SPLIT_BILL_NAME ||
      this.props.submittingPayment === true;

    return (
    <>
    <div className="is-1-col-mobile is-2-col-tablet is-2-col-desktop is-align-start">
      {this.props.activeStep !== 0 && <button
        disabled={buttonDisabled}
        className={`btn btn-back ${buttonDisabled && 'disabled'}`}
        onClick={() => {
          if (!buttonDisabled) {
            if (this.props.activeStep === Steps.BILL) {
              this.openModal();
            } else {
              this.props.popStep();
            }
          }
        }}
      >
          <img alt="null" src={chevronLeft}></img>
          <span className="btn-copy">
            Back
          </span>
      </button>}
    </div>
      <div className="home-card-title is-8-col-desktop is-8-col-tablet is-10-col-mobile is-justify-center">
        <div className="home-card-title-inner">
          <h1>{currentStep.toUpperCase()}</h1>
          <div className="table-number">{contentTableNumber}</div>
        <div className="bread-crumb-wrapper">
          <div className="restaurant-name">{restaurantNameTitle}</div>
          <div className="bread-crumb-inner">
            {!!this.props.privacyPolicyAndTermsConditionsModal ? (
              <button
                className="btn btn-close"
                onClick={() =>
                  this.props.closePrivacyPolicyTermsAndConditionsModal()
                }
              >
                <div className="btn-wrapper">
                  <span>{elementClose}</span>
                  <div className="btn-copy">
                    <p>Close</p>
                  </div>
                </div>
              </button>
            ) : !buttonDisabled ? (
              null
            ) : (
                  ''
                )}
            
            <div className="current-screen">
              {!!this.props.privacyPolicyAndTermsConditionsModal ? (
                `${
                !!this.props.termAndConditionsCopy ? "T&C's" : 'Privacy'
                }`
              ) : (
                  null
                )}
            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="is-1-col-mobile is-2-col-tablet is-2-col-desktop"></div>
    </>
    );
  }
}

export default withAppState(TopBanner,
  {
    mobXProps: ({
      activeStep,
      tableNumber,
      previousSteps,
      bill,
      restaurant,
      submittingPayment,
      sourceIsApp,
      appPlatform,
      privacyPolicyAndTermsConditionsModal,
      termAndConditionsCopy,
    }) => ({
      activeStep,
      tableNumber,
      previousSteps,
      bill,
      restaurant,
      submittingPayment,
      sourceIsApp,
      appPlatform,
      privacyPolicyAndTermsConditionsModal,
      termAndConditionsCopy,
    }),
    mobXActions: ({
      setMainModalCTA,
      setupMainModal,
      enableMainModal,
      popStep,
      closePrivacyPolicyTermsAndConditionsModal,
    }) => ({
      setMainModalCTA,
      setupMainModal,
      enableMainModal,
      popStep,
      closePrivacyPolicyTermsAndConditionsModal,
    })
  }
);